
import XTable from 'vux/src/components/x-table/index.vue'

import { mapMutations } from "vuex";
export default {
name: 'ad',
components: {
XTable
},
methods: {
...mapMutations(["hideLoad"]),
},
created() {
this.hideLoad();
},
}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/ad.vue